import React from "react";
import { Link } from "react-router-dom";

const TIERS = [
  {
    label: "Free", price: "$0", per: "", colorKey: "muted",
    features: ["Browse course catalog", "View load board", "Basic public profile", "Access demo content"],
    missing: ["Cannot apply to loads", "Cannot contact sellers", "No verified badge", "No cert upload"],
    cta: "Start Free", to: "/signup",
  },
  {
    label: "Driver Member", price: "$29", per: "/mo", colorKey: "blue", popular: true,
    badge: "Most Popular",
    features: ["Verified Driver Badge", "Apply to loads (1-click)", "Upload & verify certifications", "State Cheat Sheets", "Post on Trade Link marketplace", "Contact sellers via message", "Invoice builder", "Job history + EBHL matching"],
    cta: "Join for $29/mo", to: "/signup",
  },
  {
    label: "Company", price: "$49", per: "/mo", colorKey: "purple",
    badge: "For Carriers",
    features: ["Post unlimited loads", "Search verified drivers", "Instant cert verification", "Receive driver invoices", "QB-ready invoice export", "Fleet compliance dashboard", "ESG + carbon reporting", "GPS route compliance"],
    cta: "Register Company", to: "/company-login",
  },
];

const COLORS = {
  dark:  { blue: "#38bdf8", purple: "#a78bfa", muted: "#64748b", green: "#34d399", red: "#f87171" },
  light: { blue: "#0891b2", purple: "#7c3aed", muted: "#94a3b8", green: "#16a34a", red: "#dc2626" },
};

export default function Membership({ isDarkMode }) {
  const C      = isDarkMode ? COLORS.dark : COLORS.light;
  const bg     = isDarkMode ? "#0d1f3c"   : "#f8fafc";
  const cardBg = isDarkMode ? "#142a4d"   : "#ffffff";
  const border = isDarkMode ? "rgba(255,255,255,0.08)" : "#e2e8f0";
  const titleC = isDarkMode ? "#f0f4f8"   : "#0d1f3c";
  const bodyC  = isDarkMode ? "#94a3b8"   : "#475569";
  const textC  = isDarkMode ? "#e2e8f0"   : "#0d1f3c";
  const labelC = isDarkMode ? "#38bdf8"   : "#0891b2";

  return (
    <section style={{ padding: "72px 24px", background: bg, transition: "background 0.3s" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>

        <div style={{ textAlign: "center", marginBottom: 44 }}>
          <div style={{ color: labelC, fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: "uppercase", marginBottom: 8 }}>
            Membership
          </div>
          <h2 style={{ fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: "clamp(24px,3.5vw,34px)", fontWeight: 800, color: titleC, marginBottom: 10 }}>
            Start Free. Upgrade When Ready.
          </h2>
          <p style={{ fontSize: 15, color: bodyC, maxWidth: 500, margin: "0 auto", lineHeight: 1.75 }}>
            Browse everything for free. Become a Driver Member to get hired, post equipment, and access member-only content.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 18, marginBottom: 32 }}>
          {TIERS.map(tier => {
            const color = C[tier.colorKey];
            return (
              <div key={tier.label} style={{
                background:  cardBg,
                border:      `2px solid ${color}${tier.popular ? "50" : "20"}`,
                borderTop:   `4px solid ${color}`,
                borderRadius: 20,
                padding:     "28px",
                position:    "relative",
                boxShadow:   tier.popular
                  ? isDarkMode ? "0 8px 32px rgba(56,189,248,0.10)" : "0 8px 32px rgba(8,145,178,0.10)"
                  : "none",
                transition:  "background 0.3s, border-color 0.3s",
              }}>
                {tier.badge && (
                  <div style={{ position: "absolute", top: -13, left: "50%", transform: "translateX(-50%)", background: color, color: "#fff", fontSize: 10, fontWeight: 700, padding: "3px 14px", borderRadius: 99, whiteSpace: "nowrap" }}>
                    {tier.badge}
                  </div>
                )}
                <div style={{ marginBottom: 18 }}>
                  <div style={{ fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 800, fontSize: 18, color: titleC, marginBottom: 5 }}>{tier.label}</div>
                  <div style={{ display: "flex", alignItems: "baseline", gap: 3 }}>
                    <span style={{ fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 30, fontWeight: 800, color }}>{tier.price}</span>
                    {tier.per && <span style={{ fontSize: 13, color: bodyC }}>{tier.per}</span>}
                  </div>
                </div>
                <div style={{ marginBottom: 20 }}>
                  {tier.features.map(f => (
                    <div key={f} style={{ display: "flex", alignItems: "flex-start", gap: 7, padding: "5px 0", borderBottom: `1px solid ${color}15`, fontSize: 13, color: textC }}>
                      <span style={{ color: C.green, fontWeight: 700, flexShrink: 0 }}>✓</span>
                      <span>{f}</span>
                    </div>
                  ))}
                  {tier.missing?.map(f => (
                    <div key={f} style={{ display: "flex", alignItems: "center", gap: 7, padding: "5px 0", fontSize: 12, color: bodyC }}>
                      <span style={{ color: C.red, fontWeight: 700, flexShrink: 0 }}>✗</span>
                      <span style={{ textDecoration: "line-through" }}>{f}</span>
                    </div>
                  ))}
                </div>
                <Link to={tier.to} style={{
                  display: "block", textAlign: "center", width: "100%",
                  background: color, color: "#fff", fontWeight: 700, fontSize: 14,
                  padding: "12px 0", borderRadius: 10, textDecoration: "none",
                  transition: "filter 0.15s",
                  boxSizing: "border-box",
                }}>
                  {tier.cta} →
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
